// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pointer[data-v-1940bcef] {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/dynamic-component-editor/components/SelectCollection.vue","webpack://./SelectCollection.vue"],"names":[],"mappings":"AAEA;EACE,eAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.pointer {\n  cursor: pointer;\n}\n",".pointer {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
